<template>
  <a-card style="min-height:60vh">
    <a-row style="margin-bottom: 16px">
      <a-col>
        <a-button type="primary" @click="$router.push('/systemConfig/groupReportSetting/reportDataTemp/addDataTemp')">创建模板</a-button>
      </a-col>
    </a-row>
    <a-row>
      <a-table
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
        :columns="columns"
      >
        <template slot="templateType" slot-scope="text">
          <span>{{ types[text.templateType] }}</span>
        </template>
        <template slot="action" slot-scope="text">
          <a-button type="link" @click="edit(text)">编辑</a-button>
          <a-popconfirm title="确认删除此模板？" @confirm="del(text)">
            <a-button type="link" style="color: red">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-row>
  </a-card>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
export default {
  name: 'DataTemp',
  data() {
    return {
      types: {
        1: '创新人才模版',
      },
      tableRelevant: tableRelevant.call(this, this.getList),
      columns: [
        {
          title: '模板名称',
          dataIndex: 'name',
        },
        {
          title: '模板类型',
          scopedSlots: { customRender: 'templateType' },
        },
        {
          title: '模板简介',
          dataIndex: 'description',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
        },
      ],
      search: {
        name: undefined,
      },
      tableData: {
        data: [],
        loading: false,
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList(reset) {
      if (reset) {
        this.tableRelevant.tablePagination.current = 1
      }
      const params = {
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.search,
      }
      this.tableRelevant.tableLoading = true
      const { data } = await this.$http.GroupReportTemp.getList(params).finally(() => (this.tableRelevant.tableLoading = false))
      this.tableRelevant.tableDataSource = data.items
      this.tableRelevant.tablePagination.total = data.totalCount
      this.tableRelevant.tablePagination.current = data.pageIndex
    },
    async del(item) {
      await this.$http.GroupReportTemp.delReportTemp(item.id)
      this.$message.success('操作成功')
      this.getList(1)
    },
    edit(item) {
      this.$router.push({ path: '/systemConfig/groupReportSetting/reportDataTemp/addDataTemp', query: item })
    },
  },
}
</script>
